import NotesShortcuts from "./NotesShortcuts";

export default NotesShortcuts;
